<template>


    <div v-if="isdisplay"   class="hs-overlay  ti-offcanvas ti-offcanvas-right open opened" tabindex="-1">
        <div class="ti-offcanvas-header">
            <h5 class="ti-offcanvas-title">
                TABLES
            </h5>
            <button type="button" class="ti-btn flex-shrink-0 p-0 transition-none text-gray-500 hover:text-gray-700
                    focus:ring-gray-400 focus:ring-offset-white dark:text-[#8c9097] dark:text-white/50 dark:hover:text-white/80 dark:focus:ring-white/10
                    dark:focus:ring-offset-white/10"  @click="closeview">
                <span class="sr-only">Close modal</span>
                <svg class="w-3.5 h-3.5" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.258206 1.00652C0.351976 0.912791 0.479126 0.860131 0.611706 0.860131C0.744296 0.860131 0.871447 0.912791 0.965207 1.00652L3.61171 3.65302L6.25822 1.00652C6.30432 0.958771 6.35952 0.920671 6.42052 0.894471C6.48152 0.868271 6.54712 0.854471 6.61352 0.853901C6.67992 0.853321 6.74572 0.865971 6.80722 0.891111C6.86862 0.916251 6.92442 0.953381 6.97142 1.00032C7.01832 1.04727 7.05552 1.1031 7.08062 1.16454C7.10572 1.22599 7.11842 1.29183 7.11782 1.35822C7.11722 1.42461 7.10342 1.49022 7.07722 1.55122C7.05102 1.61222 7.01292 1.6674 6.96522 1.71352L4.31871 4.36002L6.96522 7.00648C7.05632 7.10078 7.10672 7.22708 7.10552 7.35818C7.10442 7.48928 7.05182 7.61468 6.95912 7.70738C6.86642 7.80018 6.74102 7.85268 6.60992 7.85388C6.47882 7.85498 6.35252 7.80458 6.25822 7.71348L3.61171 5.06702L0.965207 7.71348C0.870907 7.80458 0.744606 7.85498 0.613506 7.85388C0.482406 7.85268 0.357007 7.80018 0.264297 7.70738C0.171597 7.61468 0.119017 7.48928 0.117877 7.35818C0.116737 7.22708 0.167126 7.10078 0.258206 7.00648L2.90471 4.36002L0.258206 1.71352C0.164476 1.61976 0.111816 1.4926 0.111816 1.36002C0.111816 1.22744 0.164476 1.10028 0.258206 1.00652Z" fill="currentColor"></path>
                </svg>
            </button>
        </div>
        <div class="ti-offcanvas-body !h-[90%] !p-0">
            <div>

                <div class=" xl:col-span-12  col-span-12 mt-4 mb-4">
                    <input v-model="searchword"  class="form-control form-control-lg w-full" type="text"
                           placeholder="🔍 Rechercher une table..."
                           aria-label=".form-control-lg example">
                </div>


                <div class="grid grid-cols-1 gap-3 mb-6">

                    <template v-if="filterdata.length>0">

                        <div
                                v-for="table in filterdata"
                                :key="table.id"
                                @dblclick="handleserversselectTable(table);closeview();"
                                :class="['table-card bg-white rounded-lg shadow-sm p-4 border-t-4 cursor-pointer',
                         table.status === 'Libre' ? 'border-green-500' : 'border-red-500',
                         {'selected': currentTable?.id === table.id}]">
                            <div class="flex justify-between items-start">
                                <div>
                                    <p class="text-xs text-slate-500 uppercase">Table</p>
                                    <h3 class="text-lg font-bold text-slate-800">{{ table.name }}</h3>
                                    <p class="text-sm text-slate-600">{{ table.capacity }} personnes</p>
                                </div>
                                <span :class="['inline-flex items-center text-xs font-semibold px-2 py-1 rounded-full',
                                table.status === 'Libre' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700']">
                    {{ table.status }}
                  </span>
                            </div>
                        </div>






                    </template>
                    <template v-else>

                        <div

                                class="table-card bg-white rounded-lg shadow-sm p-4 border-t-4 cursor-pointer
                                border-red-500 selected">
                            <div class="flex justify-between items-start">
                                  <div>
                                    <h3 class="text-xs text-slate-500 uppercase">Aucun serveur n'a pu être trouvé.</h3>
                                    <p class="text-sm text-slate-600">-</p>

                                </div>

                            </div>
                        </div>

                    </template>


                </div>



            </div>
        </div>
    </div>


    <div @click="closeview"  v-if="isdisplay"
          class="fixed inset-0 z-40 bg-black bg-opacity-50 transition-opacity backdrop-blur-sm" style="z-index: 149;"></div>


</template>

<script>
    import { inject } from 'vue';
    export default {
        /* eslint-disable */
        name: "table",

        watch: {
           /* searchword: function(newvalue,oldvalue){

                this.page=1

            },*/


        },
        computed:{

            filterdata(){

                let mvalue=this.tables;

                if (this.searchword!==''){
                    let t=this;

                    mvalue = mvalue.filter( function (post) {
                        return    post.name.toLowerCase().includes(t.searchword.toLowerCase())

                    })
                }
                return mvalue ;
            },
        },

        data() {
            return {
                searchword: "",
                isdisplay: false,
                tables:[],
                currentTable:{}

            };
        },

        methods: {


            closeview(){
                this.isdisplay=false;
            },

            close(){
                this.isdisplay=false;

                this.$emit('closed');
            },


            show(tables,currentTable){

                this.tables=tables
                this.currentTable=currentTable

                this.isdisplay=true;

            },



        },

        setup(props) {
            // Injecter la méthode 'addCompte' provenant du parent
            const selectTable = inject('selectTable');


            const handleserversselectTable = (value) => {

                // Appel de la méthode injectée
                if (selectTable) {
                    selectTable(value);
                }

            };




            return {
                handleserversselectTable,

            };
        },



    }
</script>


<style scoped>
    .table-card, .server-card, .menu-item {
        transition: all 0.3s ease;
    }
    .table-card:hover, .server-card:hover {
        transform: translateY(-3px);
        box-shadow: 0 8px 15px -5px rgba(0, 0, 0, 0.1);
    }
    .selected {
        box-shadow: 0 0 0 3px #ecc94b;
    }
    .menu-item:hover {
        background-color: #f8fafc;
    }
    .order-item {
        animation: fadeIn 0.3s ease-in;
    }
    @keyframes fadeIn {
        from { opacity: 0; transform: translateY(10px); }
        to { opacity: 1; transform: translateY(0); }
    }
    /* Scrollbar personnalisée */
    .custom-scrollbar::-webkit-scrollbar {
        width: 6px;
    }
    .custom-scrollbar::-webkit-scrollbar-track {
        background: #f1f5f9;
    }
    .custom-scrollbar::-webkit-scrollbar-thumb {
        background: #cbd5e1;
        border-radius: 4px;
    }
    .custom-scrollbar::-webkit-scrollbar-thumb:hover {
        background: #94a3b8;
    }
    /* Transitions pour les panneaux */
    .panel-transition {
        transition: all 0.3s ease;
    }
    .toggle-panel-btn {
        transition: all 0.3s ease;
    }
    .toggle-panel-btn:hover {
        transform: scale(1.1);
    }



    .min-h-screen {
        min-height: 100vh!important;
    }

    .h-screen {
        height: 100vh!important;
    }
</style>

